<template>
  <ButtonComponent :theme="theme" :label="label" :icon="icon" @click="$bus.$emit('task', { reference })" />
</template>

<script>
export default {
  props: {
    reference: Object,
    theme: {
      type: String,
      default: 'primary',
    },
    label: {
      type: String,
      default() {
        return this.$t('createTask')
      },
    },
    icon: {
      type: String,
      default: 'fa-pro-light:plus',
    },
  },
}
</script>
